import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const purchaseOrderFreightQueryAtom = createQueryAtomFactory(
  'trade.purchaseOrderFreights',
  (params: { purchaseOrderId: string }) => ({
    purchaseOrderFreights: {
      __args: {
        filter: {
          purchaseOrderId: params.purchaseOrderId,
        },
      },
      entries: {
        id: true,
        purchaseOrderId: true,
        carrierId: true,
        freightLaneId: true,
        rateFormula: true,
        rateVariableIds: true,
        chargebackFormula: true,
        chargebackVariableIds: true,
        fuelSurchargeFormula: true,
        fuelSurchargeVariableIds: true,
        fuelSurchargeMode: true,
        notes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) => data.purchaseOrderFreights.entries[0] ?? null,
  },
);
